import { UIRouterModule } from "@uirouter/angular";
import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { LocalizationModule } from "@webapp/localization/localization.module";
import { FormModule } from "@webapp/shared/form/form.module";
import { UiModalModule } from "@webapp/ui/modal/modal.module";
import { CreateOkrFormComponent } from "./create-okr-form.component";

@NgModule({
  imports: [CommonModule, FormModule, LocalizationModule, UIRouterModule, UiModalModule],
  declarations: [CreateOkrFormComponent],
})
export class CreateOkrFormModule {}
